import React, {useRef, useCallback,} from 'react'
import {useState, useEffect} from 'react'
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import WT from '@sscale/wtsdk';
import './UserDataEntry.css';

import {login, setRoomSettings} from '../../../../store/reducers/ParticipantReducer';
import {setJoinModalType} from '../../../../store/reducers/SessionReducer'

function UserDataEntry() {
    const {pathname} = useLocation();
    const dispatch = useDispatch();

    const {gainedToken} = useSelector(state => state.participant);

    const [userData, setUserData] = useState({
        password: process.env.NODE_ENV === 'development' ? 'Celebrity@VRT$$Y4' : '',
        userName: ''
    })
    const [passwordError, setPasswordError] = useState('')
    const [loading, setLoadingState] = useState(null);
    const [videoEnabled, setVideoEnabled] = useState(false);
    const [mediaList, setMediaList] = useState([]);
    const [video, setVideo] = useState('')
    const [audio, setAudio] = useState('default')
    const [speaker, setSpeaker] = useState('default')
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification))

    const gainedTokenRef = useRef(gainedToken);
    const userDataRef = useRef(userData);
    const streamRef = useRef(null);

    useEffect(() => {
        gainedTokenRef.current = gainedToken;
    }, [gainedToken])

    useEffect(() => {
        userDataRef.current = userData;
    }, [userData])

    const connectInitialDevices = async () => {
        try {

            const constraints = {audio: true, video: true};

            streamRef.current = await WT.doPreview(constraints);

            const videoElem = document.getElementById('video-preview');

            if ("srcObject" in videoElem) {
                videoElem.srcObject = streamRef.current;
            }
            videoElem.onloadedmetadata = function (e) {
                setVideoEnabled(true)
                videoElem.play();
            };
        } catch (error) {
            console.log('error - connectInitialDevices', error)
            setVideoEnabled(false)
        }
    }

    const getDevices = async () => {
        try {
            await connectInitialDevices()

            const devices = await WT.getMediaDevices()

            console.log('devices => ', devices)

            setMediaList(devices)

            setVideo(devices.camera[0].value)

            if (isFirefox || isSafari) {
                setAudio(devices.microphone[0].value)
            }

            return devices
        } catch (e) {
            console.log('error - getDevices', e.message)
        }
    }

    useEffect(() => {
        // const devices = WT.
        getDevices();
    }, []);


    const joinWithRole = useCallback(async () => {
        const isCelebrity = pathname.includes('/c')

        if (isCelebrity && userData.password !== 'Celebrity@VRT$$Y4') {
            setPasswordError('Incorrect password')
            return;
        }

        try {
            setLoadingState(true);

            const payload = {
                userName: userDataRef?.current?.userName,
                isCelebrity,
                isViewer: false,
                token: gainedTokenRef.current,
            }

            // if (streamRef.current) {
            //     streamRef.current.getTracks().forEach(track => track && track.stop())
            // }

            console.log({audio, video})

            if(audio !== 'default') {
                WT.setAudioConstraints({deviceId: audio});
            }

            if(video) {
                WT.setVideoConstraints({deviceId: video});
            }

            if (!isCelebrity) {
                await dispatch(login(payload));
            } else {
                dispatch(setRoomSettings(payload))
            }

            // if (isCelebrity) {
            //     dispatch(getSessionList())
            // }

            dispatch(setJoinModalType(null))
        } catch (error) {
            console.log('error - joinWithRole', error.message)
        } finally {
            setLoadingState(false);
        }
    }, [dispatch, pathname, userData.password])

    useEffect(() => {
        const listener = document.addEventListener('keypress', (e) => {

            if (e.keyCode === 13) {
                e.preventDefault()

                if (!userDataRef?.current?.userName) {
                    return
                }

                joinWithRole()
            }
        })

        return () => {
            document.removeEventListener('keypress', listener)
        }
    }, [joinWithRole, dispatch, pathname, userData.password])

    function handleChange(e) {
        setUserData({...userData, [e.target.name]: e.target.value})
    }

    const handleDevice = async (event, type) => {
        const value = event.target.value

        if (type === 'microphone') {
            changeAudioDevice(value)
        }

        if (type === 'camera') {
            changeVideoDevice(value)
        }

        if (type === 'speaker') {
            changeOutputDevice(value)
            setSpeaker(value)
        }
    };

    const changeVideoDevice = async (value) => {
        const video = document.getElementById('video-preview');


        streamRef.current = await WT.doPreview({
            video: {deviceId: {exact: value}},
            audio: true,
        });

        video.srcObject = streamRef.current;

        video.onloadedmetadata = function (e) {
            setVideo(value)
            video.play();
        };
    }

    const changeAudioDevice = async (value) => {
        const videoElem = document.getElementById('video-preview');

        if (isFirefox) {
            videoElem.srcObject.getTracks().forEach(track => track.stop())
            console.log("videoElem.srcObject", videoElem.srcObject)
        }

        streamRef.current = await WT.doPreview({
            video: {deviceId: {exact: video}},
            audio: {deviceId: {exact: value}},
        });

        videoElem.srcObject = streamRef.current;

        // videoElem.srcObject.getAudioTracks()[0].enabled = audioEnabled

        videoElem.onloadedmetadata = function (e) {
            setAudio(value)
            videoElem.play();
        };
    }

    const changeOutputDevice = async (value) => {
        const videoElem = document.getElementById('video-preview');

        videoElem.setSinkId(value);
    }

    return (
        <div className='uda-container'>

            <div className='preview-container'>
                <video id='video-preview' muted={true} className='p-block'/>
            </div>

            <div style={{padding: '0 20px'}}>
                <form>

                    <div className="uda-input-container">
                        <label htmlFor="video">Video source:</label>

                        <select
                            name="video"
                            id="video"
                            onChange={(e) => handleDevice(e, 'camera')}
                            value={video}>
                            {mediaList?.camera && mediaList?.camera?.map((c, i) => (<>
                                <option key={i} value={c.value}>{c.label}</option>
                            </>))}

                        </select>
                    </div>

                    <div className="uda-input-container">
                        <label htmlFor="audio">Audio source:</label>

                        <select
                            name="audio"
                            id="audio"
                            onChange={(e) => handleDevice(e, 'microphone')}
                            value={audio}>
                            {mediaList?.microphone && mediaList?.microphone?.map((m, i) => (<>
                                <option key={i} value={m.value}>{m.label}</option>
                            </>))}

                        </select>
                    </div>

                    {(!isFirefox && !isSafari) && (
                        <div className="uda-input-container">
                            <label htmlFor="speaker">Speaker:</label>

                            <select
                                name="speaker"
                                id="speaker"
                                onChange={(e) => handleDevice(e, 'speaker')}
                                value={speaker}>
                                {mediaList?.speaker && mediaList?.speaker?.map((s, i) => (<>
                                    <option key={i} value={s.value}>{s.label}</option>
                                </>))}

                            </select>
                        </div>
                    )}

                    <div className="uda-input-container">
                        <input
                            className="uda-input"
                            name="userName"
                            placeholder='Enter your name'
                            autoFocus={true}
                            value={userData.userName}
                            onChange={handleChange}
                            id="userName"
                        />
                    </div>

                    {pathname.includes('/c') && (
                        <div className="uda-input-container">
                            <input
                                className="uda-input"
                                name="password"
                                placeholder='Enter password'
                                type='password'
                                value={userData.password}
                                onChange={handleChange}
                                onFocus={() => setPasswordError('')}
                                id="password"
                            />

                            <div className='uda-input-error'>{passwordError || ''}</div>
                        </div>
                    )}

                    <div className='uda-buttons-container'>
                        <button
                            type="button"
                            className="uda-button participant"
                            onClick={joinWithRole}
                            tabIndex={0}
                            disabled={loading || !userData.userName || (pathname.includes('/c') && !userData.password)}
                        >
                            {loading === 'participant' ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"/>
                                    <span>Connecting...</span>
                                </>
                            ) : (
                                <span>
                  Join
                </span>
                            )}
                        </button>
                    </div>
                </form>
            </div>

        </div>
    );
}

export default UserDataEntry
